/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bulkCandidateEmailDataSchema = z.object({
	campaignId: z.string(),
	candidateIds: z.array(z.string()),
	subject: z.string().nullable().optional(),
	body: z.string(),
	from: z.string().email().nullable().optional(),
	fromName: z.string().nullable().optional(),
})

export type BulkCandidateEmailDataSchema = z.infer<typeof bulkCandidateEmailDataSchema>
